import { render, staticRenderFns } from "./uodoComplaintsList.vue?vue&type=template&id=2e073248&scoped=true"
import script from "./uodoComplaintsList.vue?vue&type=script&lang=js"
export * from "./uodoComplaintsList.vue?vue&type=script&lang=js"
import style0 from "./uodoComplaintsList.vue?vue&type=style&index=0&id=2e073248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e073248",
  null
  
)

export default component.exports